var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-wrapper mt-3"},[(_vm.loaded)?_c('div',[(!_vm.hasAccess)?_c('no-access'):_c('access')],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }